import React from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import MarketingPageHero from "@/components/marketing/MarketingPageHero";
import { usePageMeta } from "@/lib/usePageMeta";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";

export default function PricingPage() {
  usePageMeta(
    "Pricing — Leadmato",
    "Simple scan-based pricing. One plan: 15 scans a month, up to 15 keywords each. Your first scan is free.",
  );
  return (
    <MarketingLayout>
      <MarketingPageHero
        eyebrow="Pricing"
        title={<>Pay per scan.<br />Not per seat, not per lead.</>}
        subtitle="Every plan runs the same 5-lens engine. Pick the volume that matches how often you go looking for customers."
      />
      <Pricing />
      <FAQ />
    </MarketingLayout>
  );
}
